﻿import Swiper, { Lazy, Pagination, Navigation } from "swiper";
import Autolinker from "autolinker";
import "swiper/scss";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/lazy";

const players = [];

const SWIPER_CLASS = "swiper";

const createSwiper = () => {
    return new Swiper("." + SWIPER_CLASS, {
        // autoHeight: true,
        modules: [Lazy, Pagination, Navigation],
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: { loadPrevNext: true },
        pagination: {
            el: ".swiper-pagination",
        },
        navigation: {
            enabled: true,
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            slideChange: function () {
                players.forEach((player) => {
                    player.pauseVideo();
                });
            },
        },
    });
};

const swiper = createSwiper();

document.addEventListener("turbo:render", async (event) => {
    swiper.destroy();
    swiper = createSwiper();
});

function onYouTubeIframeAPIReady() {
    // Check all slides and initialize video players
    var swiper = document.getElementsByClassName(SWIPER_CLASS)[0];
    var slides = swiper.getElementsByClassName("swiper-slide");

    let lang = document.querySelector("meta[name=language]").content;

    for (var i = 0; i < slides.length; i++) {
        var element = slides[i].querySelector(".js-yt-player");
        if (!element) continue;

        var id = element.getAttribute("data-id");

        var player = new window.YT.Player(element, {
            videoId: id,
            width: swiper.clientWidth,
            playerVars: {
                autoplay: false,
                hl: lang,
                modestbranding: true,
                rel: 0,
                enablejsapi: 1,
            },
        });
        players.push(player);
    }
}

// do we have any youtube videos?
let videoElements = document.querySelectorAll(".video-container");
if (videoElements.length) {
    // add the youtube api script
    var tag = document.createElement("script");
    tag.async = true;
    tag.defer = true;

    tag.src = "https://www.youtube.com/iframe_api";

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    document.documentElement.appendChild(tag);
}

let element = document.querySelector("#blog-detail .o-user-content");
if (element) {
    element.innerHTML = Autolinker.link(element.innerHTML);
}
